import directusGraphQLServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

export type PostDisplayType = "article" | "case-study"

const CASE_STUDY_CATEGORY = "case-study"

type PostDisplayOrderPost = {
  slug?: string | null
}

const getPostDisplayOrder = async ({
  isPreview = false,
  type,
}: {
  type: PostDisplayType
  isPreview?: boolean
}) => {
  const statusFilter = isPreview ? "" : 'status: { _eq: "published" }'
  const categoryFilter =
    type === "case-study"
      ? "category: { category_id: { slug: { _eq: $categorySlug } } }"
      : "category: { _none: { category_id: { slug: { _eq: $categorySlug } } } }"

  const response = await directusGraphQLServer.query(
    `
        query PostDisplayOrder($categorySlug: String!) {
          posts(
            sort: "date_created",
            limit: -1,
            filter: {
              ${statusFilter}
              ${categoryFilter}
            }
          ) {
            slug
          }
        }
      `,
    {
      categorySlug: CASE_STUDY_CATEGORY,
    }
  )

  return (response?.posts ?? []) as PostDisplayOrderPost[]
}

export const getPostDisplayNumberMap = async ({
  isPreview = false,
  type,
}: {
  type: PostDisplayType
  isPreview?: boolean
}) => {
  try {
    const posts = await getPostDisplayOrder({ isPreview, type })

    return posts.reduce<Map<string, number>>((displayNumbers, post, index) => {
      if (post.slug) {
        displayNumbers.set(post.slug, index + 1)
      }

      return displayNumbers
    }, new Map())
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error("Error in getPostDisplayNumberMap:", error)
    return new Map<string, number>()
  }
}

const getPostDisplayNumber = async ({
  isPreview = false,
  slug,
  type,
}: {
  slug: string
  type: PostDisplayType
  isPreview?: boolean
}) => {
  try {
    const posts = await getPostDisplayOrder({ isPreview, type })
    const displayIndex = posts.findIndex((post) => post.slug === slug)

    return typeof displayIndex === "number" && displayIndex >= 0
      ? displayIndex + 1
      : undefined
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error("Error in getPostDisplayNumber:", error)
    return undefined
  }
}

export default getPostDisplayNumber
